import { Link } from "react-router-dom";
import { navLinks, siteInfo } from "@/mocks/site";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-20 bg-secondary-800 text-background-100">
      <div className="h-1 w-full bg-primary-500" />
      <div className="mx-auto grid w-full max-w-[1320px] gap-10 px-4 py-14 md:grid-cols-12 md:px-6 lg:gap-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500 font-heading text-lg font-bold text-secondary-950">
              由
            </span>
            <div className="flex flex-col leading-none">
              <span className="font-heading text-lg font-bold tracking-wide">
                {siteInfo.brand}
              </span>
              <span className="mt-1 text-[10px] tracking-[0.32em] text-background-300">
                {siteInfo.brandEn}
              </span>
            </div>
          </div>
          <p className="mt-5 max-w-md text-sm leading-relaxed text-background-300">
            {siteInfo.intro}
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            {siteInfo.socials.map((s) => (
              <span
                key={s.name}
                className="flex h-10 w-10 items-center justify-center rounded-full bg-background-100/10 text-background-100 transition-colors hover:bg-accent-500 hover:text-secondary-950"
                title={s.name}
              >
                <i className={`${s.icon} text-lg`} />
              </span>
            ))}
          </div>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-heading text-sm font-semibold tracking-wide text-background-50">
            站内导航
          </h4>
          <ul className="mt-5 space-y-3">
            {navLinks.map((link) => (
              <li key={link.path}>
                <Link
                  to={link.path}
                  className="text-sm text-background-300 transition-colors hover:text-accent-300"
                >
                  {link.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="font-heading text-sm font-semibold tracking-wide text-background-50">
            官方联络
          </h4>
          <ul className="mt-5 space-y-3 text-sm text-background-300">
            <li className="flex items-start gap-3">
              <i className="ri-mail-line mt-0.5 text-base text-accent-300" />
              <span className="break-all">{siteInfo.email}</span>
            </li>
            <li className="flex items-start gap-3">
              <i className="ri-newspaper-line mt-0.5 text-base text-accent-300" />
              <span className="break-all">媒体合作：{siteInfo.pressEmail}</span>
            </li>
            <li className="flex items-start gap-3">
              <i className="ri-map-pin-line mt-0.5 text-base text-accent-300" />
              <span>{siteInfo.address}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-100/15">
        <div className="mx-auto flex w-full max-w-[1320px] flex-col gap-3 px-4 py-6 text-xs text-background-400 md:flex-row md:items-center md:justify-between md:px-6">
          <p>© {year} 风间由美官方网站 · 风间由美工作室 保留所有权利</p>
          <p className="max-w-xl leading-relaxed md:text-right">{siteInfo.disclaimer}</p>
        </div>
      </div>
    </footer>
  );
}